module.exports = __webpack_public_path__ + "static/img/collect.54d92a7e.png";